import {
  ChangeDetectionStrategy,
  Component,
  Input,
  output,
  ViewChild
} from '@angular/core';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { PrimeTemplate } from 'primeng/api';

import { MButtonComponent } from '../m-button/m-button.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-confirm-popup',
  templateUrl: './m-confirm-popup.component.html',
  styleUrl: './m-confirm-popup.component.scss',
  imports: [ConfirmPopup, PrimeTemplate, MButtonComponent]
})
export class MConfirmPopupComponent {
  @Input() styleClass = '';
  @Input() rejectVisible = true;
  @Input() acceptLabel = 'Submit';
  @Input() rejectLabel = 'Cancel';
  @Input() autoZIndex = true;
  @Input() header = 'Custom Header';
  @Input() message = 'Custom Content goes here';
  @Input() key!: string;
  // eslint-disable-next-line @angular-eslint/no-output-native
  readonly cancel = output<Event>();
  readonly apply = output<Event>();

  @ViewChild('confirmPopup') confirmPopup!: ConfirmPopup;

  onCancel(event: Event) {
    this.cancel.emit(event);
    this.confirmPopup.hide();
  }

  onSubmit(event: Event) {
    this.apply.emit(event);
    this.confirmPopup.hide();
  }
}
